"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Sparkle16DefaultSvg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { d: "M1 8.947C4.10162 8.56007 6.55988 6.10168 6.9466 3H7.05267C7.43942 6.10193 9.89803 8.56046 13 8.94709V9.05309C9.89809 9.43971 7.43952 11.8982 7.05269 15H6.94657C6.55978 11.8984 4.10156 9.4401 1 9.05318L1 8.947Z", fill: "#5E30E3" }),
        react_1.default.createElement("path", { d: "M11 2.98233C12.0339 2.85336 12.8533 2.03389 12.9822 1H13.0176C13.1465 2.03398 13.966 2.85349 15 2.98236V3.0177C13.966 3.14657 13.1465 3.96605 13.0176 5H12.9822C12.8533 3.96613 12.0339 3.1467 11 3.01773L11 2.98233Z", fill: "black" }));
}
function Sparkle16Default(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Sparkle16DefaultSvg, Object.assign({}, svgProps)));
}
exports.default = Sparkle16Default;
//# sourceMappingURL=Sparkle16Default.js.map